module.exports = __webpack_public_path__ + "static/media/reddit.d950fe5e.png";